export default {
    data () {
        return {
            users: [],
        };
    },
    methods: {
        fetchUsers (input = null, portfolioId = null, perPage = 30) {
            return new Promise((resolve, reject) => {
                axios.get("/users", {
                    params: {
                        search_text: input,
                        portfolio_id: portfolioId,
                        per_page: perPage,
                        status: "active",
                        user_type: "team_users"
                    }
                })
                .then(response => {
                    this.users = response.data.data;
                    resolve();
                })
                .catch(errors => {
                    reject();
                    toastr.error(errors.message);
                });
            });
        },
    },
};